import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import CommonHeader from 'modules/locations/components/CommonHeader'

const Container = () => {
  const { id } = useStrictParams<'id'>()

  return (
    <CommonHeader locationId={+id}>
      <Outlet context={{ locationId: +id }} />
    </CommonHeader>
  )
}

export default Container
